import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import { Card, Grid } from "@mui/material";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import SubCategoryController from "./controllers/SubCategoryController";
import { useLocation } from "react-router-dom";

export default function SubCategory() {
  const location = useLocation();
  const categoryName = location.state?.categoryTitle || "";
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info">
                <MDTypography variant="h3" color="white">
                  Listado de subcategorias de la categoría: {categoryName}
                </MDTypography>
              </MDBox>
              <MDBox>
                <SubCategoryController />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
